<template lang="pug">
    .mit
        .container
            .text
                h3(v-if="heading") {{ heading }}
                div(v-if="text" v-html="text")
            .collage
                img(src="@/assets/collage.png")
                .tooltips
                    component.portrait(
                        v-for="portrait in portraits" :key="portrait.key"
                        :is="portrait.link ? 'a' : 'div'"
                        :class="portrait.key"
                        :href="portrait.link"
                        :title="portrait.name"
                        :style="portrait.style"
                        v-tooltip="{ content: portrait.name, pacement: 'top' }"
                        target="_blank"
                    )
</template>

<script>

import _ from 'lodash'

export default {
    name: 'Collage',
    data: () => ({
        portraits: [
            {
                // 1
                key: 'berger-christian',
                name: 'Berger, Christian',
                link: 'https://www.christian-berger.nrw/',
                style: {
                    width: '5.5%',
                    height: '16.6%',
                    left: '10.7%',
                    top: '32.5%',
                }
            },
            {
                // 2
                key: 'bloming-jorg',
                name: 'Blöming, Jörg',
                link: 'https://www.joerg-bloeming.de/',
                style: {
                    width: '5.5%',
                    height: '16.6%',
                    left: '12%',
                    top: '16.1%',
                }
            },
            {
                // 3
                key: 'blumenrath-peter',
                name: 'Blumenrath, Peter',
                link: 'https://www.peterblumenrath.nrw/',
                style: {
                    width: '5.5%',
                    height: '16.6%',
                    left: '5.2%',
                    top: '32.5%',
                }
            },
            {
                // 4
                key: 'deus-guido',
                name: 'Déus, Guido',
                link: 'https://www.guido-deus.de/',
                style: {
                    width: '5.5%',
                    height: '16.6%',
                    left: '2.7%',
                    top: '49%',
                }
            },
            {
                // 5
                key: 'eggers-matthias',
                name: 'Eggers, Matthias',
                link: 'https://www.matthias-eggers.de/',
                style: {
                    width: '6.6%',
                    height: '16.6%',
                    left: '1.7%',
                    top: '65.7%',
                }
            },
            {
                // 6
                key: 'erwin-angela',
                name: 'Erwin, Angela',
                link: 'https://www.angelaerwin.de/',
                style: {
                    width: '6.5%',
                    height: '16.6%',
                    left: '16.4%',
                    top: '32.5%',
                }
            },
            {
                // 7
                key: 'frohn-anika',
                name: 'Fohn, Annika',
                link: 'https://www.annika-fohn.de/',
                style: {
                    width: '6.5%',
                    height: '16.6%',
                    left: '16.6%',
                    top: '81.8%',
                }
            },
            {
                // 8
                key: 'franken-bjorn',
                name: 'Franken, Björn',
                link: 'https://www.bjoern-franken.de/',
                style: {
                    width: '5.5%',
                    height: '16.6%',
                    left: '6.6%',
                    top: '16.1%',
                }
            },
            {
                // 9
                key: 'frentrup-mechthild',
                name: 'Frentrup, Mechthild',
                link: 'https://www.mechthildfrentrup.de/',
                style: {
                    width: '5.5%',
                    height: '16.6%',
                    left: '5.8%',
                    top: '81.8%',
                }
            },
            {
                // 10
                key: 'frieling-heinrich',
                name: 'Frieling, Heinrich',
                link: 'https://www.heinrich-frieling.de/',
                style: {
                    width: '5.5%',
                    height: '16.6%',
                    left: '7.1%',
                    top: '65.7%',
                }
            },
            {
                // 11
                key: 'fuchs-jessica',
                name: 'Fuchs, Jessica',
                link: 'https://www.jessicafuchs.de/',
                style: {
                    width: '5.9%',
                    height: '16.6%',
                    left: '8.2%',
                    top: '48.9%',
                }
            },
            {
                // 12
                key: 'geerlings-jorg',
                name: 'Geerlings, Jörg',
                link: 'https://www.geerlings.de/',
                style: {
                    width: '6.1%',
                    height: '16.6%',
                    left: '14.8%',
                    top: '0%',
                }
            },
            {
                // 13
                key: 'goken-matthias',
                name: 'Goeken, Matthias',
                link: 'https://www.matthias-goeken.de/',
                style: {
                    width: '5.2%',
                    height: '16.6%',
                    left: '35.9%',
                    top: '81.8%',
                }
            },
            {
                // 14
                key: 'essen-eva',
                name: 'Großimlinghaus, Eva',
                link: 'https://www.eva-essen.de/',
                style: {
                    width: '5.7%',
                    height: '16.6%',
                    left: '15.8%',
                    top: '65.5%',
                }
            },
            {
                // 15
                key: 'hansen-klaus',
                name: 'Hansen, Klaus',
                link: 'https://www.3fuerlippe.de/',
                style: {
                    width: '4.5%',
                    height: '16.6%',
                    left: '17.4%',
                    top: '16.1%',
                }
            },
            {
                // 16
                key: 'hausmann-wilhelm',
                name: 'Hausmann, Wilhelm',
                link: 'https://www.wilhelmhausmann.de/',
                style: {
                    width: '6.5%',
                    height: '16.6%',
                    left: '23%',
                    top: '81.8%',
                }
            },
            {
                // 17
                key: 'heinisch-jan-volke',
                name: 'Heinisch, Jan Volke',
                link: 'https://www.jan-heinisch.de/',
                style: {
                    width: '7.2%',
                    height: '16.6%',
                    left: '15.8%',
                    top: '49%',
                }
            },
            {
                // 18
                key: 'herhausen-hans-jorg',
                name: 'Herhausen, Hans-Jörg',
                link: 'https://www.joerg-herhausen.de/',
                style: {
                    width: '5.5%',
                    height: '16.6%',
                    left: '35.6%',
                    top: '16.1%',
                }
            },
            {
                // 19
                key: 'honer-markus',
                name: 'Höner, Markus',
                link: 'https://www.hoener.nrw/',
                style: {
                    width: '6.1%',
                    height: '16.6%',
                    left: '8.7%',
                    top: '0%',
                }
            },
            {
                // 20
                key: 'hoppe-biermeyer-bernhard',
                name: 'Hoppe-Biermeyer, Bernhard',
                link: 'https://www.fit-fuer-nrw.de/',
                style: {
                    width: '5.5%',
                    height: '16.6%',
                    left: '0.3%',
                    top: '81.8%',
                }
            },
            {
                // 21
                key: 'hovenjurgen-josef',
                name: 'Hovenjürgen, Josef',
                link: 'https://www.josef-hovenjuergen.de/',
                style: {
                    width: '5.7%',
                    height: '16.6%',
                    left: '60.9%',
                    top: '0%',
                }
            },
            {
                // 22
                key: 'kaiser-klaus',
                name: 'Kaiser, Klaus',
                link: 'https://www.kaiser-cdu.de/',
                style: {
                    width: '7.8%',
                    height: '16.6%',
                    left: '33.2%',
                    top: '0%',
                }
            },
            {
                // 23
                key: 'kamieth-jens',
                name: 'Kamieth, Jens',
                link: 'https://www.jenskamieth.de/',
                style: {
                    width: '5.2%',
                    height: '16.6%',
                    left: '40.9%',
                    top: '0%',
                }
            },
            {
                // 25
                key: 'kerkhoff-matthias',
                name: 'Kerkhoff, Matthias',
                link: 'https://www.matthias-kerkhoff.de/',
                style: {
                    width: '5.2%',
                    height: '16.6%',
                    left: '30.5%',
                    top: '16%',
                }
            },
            {
                // 26
                key: 'klapperich-stefan',
                name: 'Klapperich, Stefan',
                link: 'https://www.stefan-klapperich.de/',
                style: {
                    width: '5.2%',
                    height: '16.6%',
                    left: '40.9%',
                    top: '32.5%',
                }
            },
            {
                // 30
                key: 'kruckel-bernd',
                name: 'Krückel, Bernd',
                link: 'https://www.bernd-krueckel.nrw/',
                style: {
                    width: '5.2%',
                    height: '16.6%',
                    left: '40.9%',
                    top: '16%',
                }
            },
            {
                // 31
                key: 'kuper-andre',
                name: 'Kuper, André',
                link: 'https://www.andre-kuper.de/',
                style: {
                    width: '6.6%',
                    height: '16.6%',
                    left: '28.9%',
                    top: '32.5%',
                }
            },
            {
                // 42
                key: 'schirmer-maurice',
                name: 'Schirmer, Maurice',
                link: undefined,
                style: {
                    width: '4.9%',
                    height: '16.6%',
                    left: '36.2%',
                    top: '49.1%',
                }
            },
            {
                // 43
                key: 'schmitz-hendrik',
                name: 'Schmitz, Hendrik',
                link: 'https://www.hendrikschmitz.de/',
                style: {
                    width: '8.9%',
                    height: '16.6%',
                    left: '26.5%',
                    top: '49.1%',
                }
            },
            {
                // 47
                key: 'sieveke-daniel',
                name: 'Sieveke, Daniel',
                link: 'https://www.daniel-sieveke.de/',
                style: {
                    width: '5.1%',
                    height: '16.6%',
                    left: '41%',
                    top: '49.1%',
                }
            },
            {
                // 59
                key: 'gartz-simone',
                name: 'Gartz, Simone',
                link: undefined,
                style: {
                    width: '4.9%',
                    height: '16.6%',
                    left: '36.2%',
                    top: '32.5%',
                }
            },
            {
                // 28
                key: 'kramer-sarah',
                name: 'Kramer, Sarah',
                link: 'https://www.sarah-kramer.de/',
                style: {
                    width: '5.1%',
                    height: '16.6%',
                    left: '41%',
                    top: '65.8%',
                }
            },
            {
                // 27
                key: 'klenner-jochen',
                name: 'Klenner, Jochen',
                link: 'https://www.jochen-klenner.de/',
                style: {
                    width: '5.1%',
                    height: '16.6%',
                    left: '36%',
                    top: '65.8%',
                }
            },
            {
                // 49
                key: 'stehr-simone-tatjana',
                name: 'Stehr, Simone-Tatjana',
                link: 'https://www.simone-tajana-stehr.de/',
                style: {
                    width: '5.6%',
                    height: '16.6%',
                    left: '27.1%',
                    top: '65.8%',
                }
            },
            {
                // 53
                key: 'voussem-klaus',
                name: 'Voussem, Klaus',
                link: 'https://klaus-voussem.de/',
                style: {
                    width: '5.8%',
                    height: '16.6%',
                    left: '21.3%',
                    top: '65.8%',
                }
            },
            {
                // 29
                key: 'krauss-oliver',
                name: 'Krauß, Oliver',
                link: 'https://www.oliver-krauss.nrw/',
                style: {
                    width: '5.2%',
                    height: '16.6%',
                    left: '41%',
                    top: '81.8%',
                }
            },
            {
                // 33
                key: 'lienenkamper-lutz',
                name: 'Lienenkämper, Lutz',
                link: 'https://www.lutz-lienenkaemper.de/',
                style: {
                    width: '5.4%',
                    height: '16.6%',
                    left: '51.3%',
                    top: '81.8%',
                }
            },
            {
                // 35
                key: 'odermatt-vanessa',
                name: 'Odermatt, Vanessa',
                link: 'https://www.vanessa-odermatt.de/',
                style: {
                    width: '5.4%',
                    height: '16.6%',
                    left: '56.7%',
                    top: '81.8%',
                }
            },
            {
                // 38
                key: 'peill-patricia',
                name: 'Peill, Patricia',
                link: 'https://www.patriciapeill.de/',
                style: {
                    width: '5.6%',
                    height: '16.6%',
                    left: '57.7%',
                    top: '65.6%',
                }
            },
            {
                // 44
                key: 'schnelle-thomas',
                name: 'Schnelle, Thomas',
                link: 'https://www.thomas-schnelle.nrw/',
                style: {
                    width: '5.7%',
                    height: '16.6%',
                    left: '52.1%',
                    top: '65.6%',
                }
            },
            {
                // 39
                key: 'quik-charlotte',
                name: 'Quik, Charlotte',
                link: 'https://www.charlotte-quik.de/',
                style: {
                    width: '5.7%',
                    height: '16.6%',
                    left: '52.7%',
                    top: '49.2%',
                }
            },
            {
                // 37
                key: 'panske-dietmar',
                name: 'Panske, Dietmar',
                link: 'https://www.dietmar-panske.de/',
                style: {
                    width: '5.7%',
                    height: '16.6%',
                    left: '58.4%',
                    top: '49.2%',
                }
            },
            {
                // 41
                key: 'scharrenbach-ina',
                name: 'Scharrenbach, Ina',
                link: 'https://www.inascharrenbach.de/',
                style: {
                    width: '5.7%',
                    height: '16.6%',
                    left: '59.4%',
                    top: '32.5%',
                }
            },
            {
                // 48
                key: 'spiecker-rainer',
                name: 'Spiecker, Rainer',
                link: 'https://www.rainer-spiecker.de/',
                style: {
                    width: '5.7%',
                    height: '16.6%',
                    left: '53.7%',
                    top: '32.5%',
                }
            },
            {
                // 32
                key: 'lehne-olaf',
                name: 'Lehne, Olaf',
                link: 'https://www.olaf-lehne.de/',
                style: {
                    width: '5.7%',
                    height: '16.6%',
                    left: '54.5%',
                    top: '16.1%',
                }
            },
            {
                // 36
                key: 'okos-thomas',
                name: 'Okos, Thomas',
                link: 'https://www.thomas-okos.de/',
                style: {
                    width: '5.7%',
                    height: '16.6%',
                    left: '60.2%',
                    top: '16.1%',
                }
            },
            {
                // 34
                key: 'nettekoven-jens-peter',
                name: 'Nettekoven, Jens-Peter',
                link: 'https://www.nettekoven.nrw/',
                style: {
                    width: '5.7%',
                    height: '16.6%',
                    left: '55.3%',
                    top: '0%',
                }
            },
            {
                // 46
                key: 'schwarzkopf-ralf',
                name: 'Schwarzkopf, Ralf',
                link: 'https://www.ralf-schwarzkopf.de/',
                style: {
                    width: '6.4%',
                    height: '23.1%',
                    left: '68.9%',
                    top: '0%',
                }
            },
            {
                // 55
                key: 'wolters-stephan',
                name: 'Wolters, Stephan',
                link: 'https://www.stephan-wolters.de/',
                style: {
                    width: '6.1%',
                    height: '23.1%',
                    left: '75.2%',
                    top: '0%',
                }
            },
            {
                // 60
                key: 'wieczorek-beatrix',
                name: 'Wieczorek, Beatrix',
                link: undefined,
                style: {
                    width: '6.1%',
                    height: '23.1%',
                    left: '81.3%',
                    top: '0%',
                }
            },
            {
                // 56
                key: 'wust-hendrik',
                name: 'Wüst, Hendrik',
                link: 'http://www.hendrik-wuest.de/',
                style: {
                    width: '6.1%',
                    height: '23.1%',
                    left: '87.4%',
                    top: '0%',
                }
            },
            {
                // 57
                key: 'zilian-marcal',
                name: 'Zilian, Marcal',
                link: 'http://www.marcal-zilian.de/',
                style: {
                    width: '6.1%',
                    height: '23.1%',
                    left: '93.5%',
                    top: '0%',
                }
            },
            {
                // 58
                key: 'zupancic-julia',
                name: 'Zupancic, Julia',
                link: 'http://www.julia.nrw/',
                style: {
                    width: '6.2%',
                    height: '19%',
                    left: '78.1%',
                    top: '22.8%',
                }
            },
            {
                // 52
                key: 'vogt-petra',
                name: 'Vogt, Petra',
                link: 'http://www.petra-vogt-cdu.de/',
                style: {
                    width: '5.2%',
                    height: '19%',
                    left: '84.3%',
                    top: '22.8%',
                }
            },
            {
                // 50
                key: 'troles-heike',
                name: 'Troles, Heike',
                link: 'http://www.heiketroles.de/',
                style: {
                    width: '5.2%',
                    height: '19%',
                    left: '83.1%',
                    top: '41.7%',
                }
            },
            {
                // 51
                key: 'untrieser-christian',
                name: 'Untrieser, Christian',
                link: 'http://www.untrieser.de/',
                style: {
                    width: '6%',
                    height: '19%',
                    left: '77.1%',
                    top: '41.7%',
                }
            },
            {
                // 24
                key: 'kehrl-oliver',
                name: 'Kehrl, Oliver',
                link: 'http://www.oliver-kehrl.koeln/',
                style: {
                    width: '5.7%',
                    height: '19%',
                    left: '76%',
                    top: '60.6%',
                }
            },
            {
                // 54
                key: 'wendland-simone',
                name: 'Wendland, Simone',
                link: 'http://www.simone-wendland.nrw/',
                style: {
                    width: '5.7%',
                    height: '19%',
                    left: '81.8%',
                    top: '60.6%',
                }
            },
            {
                // 45
                key: 'schulze-focking-christina',
                name: 'Schulze-Föcking, Christina',
                link: 'http://www.schulze-foecking.de/',
                style: {
                    width: '5.7%',
                    height: '19%',
                    left: '80.7%',
                    top: '79.4%',
                }
            },
            {
                // 40
                key: 'ritter-jochen',
                name: 'Ritter, Jochen',
                link: 'http://www.jochenritter.de/',
                style: {
                    width: '5.7%',
                    height: '19%',
                    left: '75.1%',
                    top: '79.4%',
                }
            },
        ]
    }),
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    computed: {
        heading() {
            return _.get(this.section, 'contents.0.title');
        },
        text() {
            return _.get(this.section, 'contents.0.text');
        },
    },
}
</script>

<style lang="sass">
@import '~@/assets/sass/variables';

.mit
    margin: 3rem 0
    padding: 3rem 0
    background-color: $lightgray
    .container
        padding: 0 0.75rem

        h3
            margin-top: 0
            color: $primary
            font-weight: 600
            font-size: 1.2rem
            margin-bottom: 0.5rem
        .text
            margin-bottom: 3rem

        .collage
            position: relative
            .tooltips
                position: absolute
                left: 0
                top: 0
                width: 100%
                height: 100%
            .portrait
                display: block
                position: absolute
</style>
